"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iParticipant = exports.iBidInfo = exports.iMail = exports.iCreateMail = exports.iNote = exports.iQuestion = exports.iCreateQuestion = exports.iBidList = exports.iBid = exports.iExtraFields = exports.iCreateBid = exports.iPrintOrders = exports.iBidBuyer = exports.iReliablePartnerStatusValue = exports.iReliablePartnerStatus = void 0;
const t = require("io-ts");
const user_1 = require("./user");
const file_1 = require("./file");
const finishing_1 = require("./finishing");
const billingInformation_1 = require("./billingInformation");
const mail = require("./mail");
const reliable_partner_status_1 = require("./reliable-partner-status");
var reliable_partner_status_2 = require("./reliable-partner-status");
Object.defineProperty(exports, "iReliablePartnerStatus", { enumerable: true, get: function () { return reliable_partner_status_2.iReliablePartnerStatus; } });
Object.defineProperty(exports, "iReliablePartnerStatusValue", { enumerable: true, get: function () { return reliable_partner_status_2.iReliablePartnerStatusValue; } });
const _iBidBuyer = t.interface({
    name: t.string,
    email: t.string,
    telephone: t.string,
    company: t.string,
    street: t.string,
    postalCode: t.string,
    city: t.string,
    vatNumber: t.string
});
exports.iBidBuyer = t.clean(_iBidBuyer);
const iProcerements = t.interface({
    doNotReceiveTenders: t.boolean,
    preQualification: t.boolean,
    preQualificationDeadline: t.union([t.number, t.null]),
    negotitation: t.boolean,
    negotitationEndAt: t.union([t.number, t.null]),
    suitabilityAndFinancialProposals: t.boolean,
    lockTenders: t.boolean,
    openingEvent: t.boolean,
    openingEventAt: t.union([t.number, t.null]),
    questionsAndAnswers: t.boolean,
    questionsAndAnswersDeadline: t.union([t.number, t.null]),
    questionsAndAnswersPublishedAt: t.union([t.number, t.null]),
    reliablePartnerReport: t.boolean
});
const _iPrintOrders = t.interface({
    provideCopies: t.number,
    finishing: t.union([finishing_1.iFinishing, t.null]),
    billingInformation: t.union([billingInformation_1.iBillingInformation, t.null]),
    approveRequired: t.boolean
});
exports.iPrintOrders = t.clean(_iPrintOrders);
const _iCreateBid = t.interface({
    name: t.string,
    description: t.string,
    buyer: exports.iBidBuyer,
    startAt: t.union([t.number, t.null]),
    endAt: t.union([t.number, t.null]),
    printOrders: exports.iPrintOrders,
    procerement: iProcerements
});
exports.iCreateBid = t.clean(_iCreateBid);
const _iExtraFields = t.intersection([
    t.union([
        t.interface({
            id: t.number,
            uuid: t.string,
            name: t.string,
            status: t.union([t.literal('BID'), t.literal('ADDENDUMS')]),
            description: t.string,
            registrationLink: t.string,
            updatedAt: t.union([t.number, t.null]),
            publishedAt: t.union([t.number, t.null]),
            deletedAt: t.union([t.number, t.null]),
            createdAt: t.number
        }),
        t.interface({
            id: t.number,
            uuid: t.string,
            name: t.string,
            status: t.union([t.literal('DRAFT_BID'), t.literal('DRAFT_ADDENDUMS')]),
            description: t.string,
            updatedAt: t.union([t.number, t.null]),
            deletedAt: t.union([t.number, t.null]),
            createdAt: t.number
        })
    ]),
    exports.iCreateBid
]);
exports.iExtraFields = t.clean(_iExtraFields);
const _iBid = t.intersection([file_1.iFolder, exports.iExtraFields]);
exports.iBid = t.clean(_iBid);
exports.iBidList = t.intersection([
    file_1.iFolder,
    t.partial({
        participants: t.number,
        tenderDocuments: t.number,
        suitabilityDocuments: t.number,
        reliablePartnerReports: t.number,
        requestToParticipantDocuments: t.number
    })
]);
exports.iCreateQuestion = t.interface({
    question: t.string,
    answer: t.union([t.string, t.null])
});
exports.iQuestion = t.intersection([
    t.interface({
        id: t.number,
        bidUuid: t.string,
        createdAt: t.number,
        answer: t.union([t.string, t.null]),
        answeredAt: t.union([t.number, t.null]),
        exclude: t.boolean
    }),
    exports.iCreateQuestion
]);
exports.iNote = t.interface({
    id: t.number,
    bidUuid: t.string,
    participantUuid: t.string,
    note: t.string,
    createdAt: t.number,
    author: user_1.iAuthor
});
const _iCreateMail = t.intersection([
    mail.iCreateMail,
    t.interface({
        bid: exports.iBid
    })
]);
exports.iCreateMail = t.clean(_iCreateMail);
const _iMail = t.intersection([
    mail.iMail,
    t.interface({
        bidId: t.number
    })
]);
exports.iMail = t.clean(_iMail);
const _iBidInfo = t.interface({
    startAt: t.union([t.number, t.null]),
    endAt: t.union([t.number, t.null]),
    preQualificationDeadline: t.union([t.number, t.null]),
    updatedAt: t.union([t.number, t.null]),
    deletedAt: t.union([t.number, t.null])
});
exports.iBidInfo = t.clean(_iBidInfo);
exports.iParticipant = t.interface({
    user: user_1.iUser,
    offerSubmitted: t.union([t.number, t.null]),
    company: t.union([t.string, t.null]),
    businessId: t.union([t.string, t.null]),
    reliablePartnerStatus: t.union([reliable_partner_status_1.iReliablePartnerStatus, t.null])
});
//# sourceMappingURL=bid.js.map